export const ValidateFileSize = (file) => {
  const company = localStorage.getItem("company")
    ? JSON.parse(localStorage.getItem("company"))
    : null;
  const maxSize = company.max_file_size || 5 * 1024 * 1024;

  if (file.size > maxSize) {
    return {
      isValid: false,
      error: `The file (${
        file.name
      }) size exceeds the maximum file upload limit (${
        ((maxSize / 1024) / 1024).toFixed(0)
      }MB)`,
    };
  }
  return { isValid: true };
};


export const calculateTotalFileSize = (files) => {
  if (!files || typeof files !== "object") return 0;

  return Object.values(files).reduce((acc, fileGroup) => {
    const groupArray = Array.isArray(fileGroup)
      ? fileGroup
      : Array.from(fileGroup || []); // ensure always iterable

    const groupTotal = groupArray.reduce((sum, file) => sum + (file?.size || 0), 0);
    return acc + groupTotal;
  }, 0);
};
